module.exports = __webpack_public_path__ + "img/dep_dairy.228b431c.png";